module.exports = __webpack_public_path__ + "img/T926.2227efac.jpg";